import { __rest } from 'tslib';
import React from 'react';
import { styled } from '../../../libs/styled.es.js';
import { Input } from '../../atoms/Input/Input.es.js';
import { Button } from '../../atoms/Button/Button.es.js';
import { useTheme } from '../../../contexts/ThemeProvider.es.js';

const StyledSearchBar = styled.div(({ theme, tintColor, barStyle }) => {
    const bgColor = tintColor ? tintColor : theme.colors.gray100;
    const borderRadius = `var(--search-bar-border-radius ,8px)`;
    const styles = {
        display: 'flex',
    };
    switch (barStyle) {
        case 'nav':
            styles['backgroundColor'] = bgColor;
            styles['borderRadius'] = '8px';
            styles['.search-icon'] = {
                backgroundColor: 'transparent',
                order: -1,
            };
            styles['.search-input'] = {
                paddingLeft: 0,
            };
            break;
        case 'light': {
            styles['backgroundColor'] = '#f6f6f6';
            styles['borderRadius'] = '8px';
            styles['.search-icon'] = {
                backgroundColor: 'transparent',
                order: -1,
            };
            styles['.search-input'] = {
                paddingLeft: 0,
            };
            break;
        }
        default:
            styles['backgroundColor'] = bgColor;
            styles.border = `1px solid ${bgColor}`;
            styles.padding = '1px';
            styles['borderRadius'] = borderRadius;
            styles['--button-icon-border-radius'] = borderRadius;
            break;
    }
    return styles;
});
const StyledInput = styled(Input) `
  border: 0;
  background-color: transparent;
  flex: 1;
`;
const StyledButtonIcon = styled(Button) `
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
`;
const SearchBar = (_a) => {
    var { placeholder, prepend, searchIconProps, tintColor, barStyle, className, onClickIcon, onClickInput } = _a, inputProps = __rest(_a, ["placeholder", "prepend", "searchIconProps", "tintColor", "barStyle", "className", "onClickIcon", "onClickInput"]);
    const theme = useTheme();
    return (React.createElement(StyledSearchBar, { tintColor: tintColor, barStyle: barStyle, className: className },
        prepend,
        React.createElement(StyledInput, Object.assign({ className: "search-input", placeholder: placeholder, onClick: onClickInput, role: "searchbox", "aria-label": "Search" }, inputProps)),
        React.createElement(StyledButtonIcon, Object.assign({ onClick: onClickIcon, className: "search-icon", variant: "primary", "aria-label": "Search", icon: { name: 'search', size: 26, color: theme.colors.white } }, searchIconProps))));
};

export { SearchBar };
